import ApiClient from "@common/api/ApiClient";

/**
 * Class representing a client for customer interactions.
 * Extends the ApiClient to provide specific functionalities for API requests.
 *
 * @extends ApiClient
 */
class CustomerClient extends ApiClient {
  /**
   * Create a CustomerInteractionClient.
   * Initializes the API client with the "CustomerInteraction" route and sets the API URL key.
   */
  constructor() {
    super("Customer");
    this.setApiUrlKey("comp_api_url");
  }

  MetaData = async () => await this.get("Create");

  Create = async (payload) => await this.post("Create", payload);

  Read = async (id) => await this.get(`Read?id=${id}&includeImages=true`);

  UpdateMetaData = async (id) => await this.get(`Update?id=${id}`);

  Update = async (payload) => await this.post("Update", payload);

  Delete = async (id) => await this.get(`Delete?id=${id}`);

  SearchMetaData = async () => await this.get(`Search`);

  Search = async (
    payload = {
      ageRangeId: null,
      buildId: null,
      ethnicityId: null,
      genderId: null,
      hairId: null,
      heightId: 1,
      features: null,
      postcode: "Post",
      phoneNumber: null,
      emailAddress: null,
      address1: null,
      address2: null,
      town: null,
      id: null,
      name: null,
      description: null,
      lastUpdated: null,
      lastUpdatedTo: null,
      lastUpdatedFrom: null,
      isDisabled: null,
      foreignPK: null,
    },
  ) => await this.post("Search", payload);

  GetSessions = async (customerId) =>
    await this.get(`Sessions?customerId=${customerId}`);

  Sessions = async (payload) => await this.post("Sessions", payload);

  CompleteReview = async ({ customerId, id = 0, rowVersion, form }) => {
    await this.post(`CompleteReview`, {
      id,
      customerId,
      rowVersion,
      ...form,
    });
  };

  AddReview = async ({ customerId, reviewId, form }) => {
    await this.post(`AddReview`, {
      customerId,
      ...form,
    });
  };

  GetReviewMeta = async () => {
    return await this.get(`CompleteReview`);
  };
}

const client = new CustomerClient();

export default client;
